import React from 'react';

interface IWarningInfoProps {
	size?: string;
	className?: string;
}

export const WarningInfo = ({ size = '24', className = '' }: IWarningInfoProps) => {
	return (
		<svg
			role="img"
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			aria-labelledby="warningTitle">
			<title id="warningTitle">warning icon</title>
			<path
				d="M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12Z"
				fill="#ffcc00"
			/>
			<path d="M12 15.9583V12.2083V15.9583Z" fill="#3D3D3D" />
			<path
				d="M12 15.9583V12.2083"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M12 7C11.7528 7 11.5111 7.07331 11.3055 7.21066C11.1 7.34802 10.9398 7.54324 10.8452 7.77165C10.7505 8.00005 10.7258 8.25139 10.774 8.49386C10.8223 8.73634 10.9413 8.95907 11.1161 9.13388C11.2909 9.3087 11.5137 9.42775 11.7561 9.47598C11.9986 9.52421 12.2499 9.49946 12.4784 9.40485C12.7068 9.31024 12.902 9.15002 13.0393 8.94446C13.1767 8.7389 13.25 8.49723 13.25 8.25C13.25 7.91848 13.1183 7.60054 12.8839 7.36612C12.6495 7.1317 12.3315 7 12 7Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
